<template>
	<module class="m-timeline m-module" :title="title">
		<div ref="scroll" class="content-box flex-grow">
			<div ref="content" class="content" :class="{'z-scroll': timelineScroll}" :style="{'animation-duration': timelineScroll / 20 + 's'}">
				<ul v-for="(list, i) in scrollList" :key="i" :style="{'padding-left': px(labelWidth) + 'px'}">
					<li v-for="(item, j) in list" :key="j">
						<label>{{item.name}}</label>
						<p>{{item.content}}</p>
					</li>
				</ul>
			</div>
		</div>
	</module>
</template>

<script>
	import module from './digital_module.vue'
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		components: {
			module
		},

		props: {
			id: [Number, String]
		},

		data() {
			return {
				...getStore(this, 'digitalStore'),
				title: '时间轴',
				dataList: [],
				timelineScroll: false
			}
		},

		computed: {
			...mapStore('digitalStore', ['px', 'charsLength']),

			scrollList() {
				return this.timelineScroll ? [this.dataList, this.dataList] : [this.dataList];
			},

			labelWidth() {
				return Math.max.apply(window, this.dataList.map(({name}) => {
					return this.charsLength(name) * 15;
				}));
			}
		},
		
		mounted() {
			this.update();
		},
		
		beforeDestroy() {
			clearTimeout(this._updateTimer);
		},

		methods: {
			update() {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						this.title = data.childModule.title;
						this.dataList = data.childModule.list;
						this.timelineScroll = false;
						this.$nextTick(() => {
							this.timelineScroll = this.$refs.content.clientHeight > this.$refs.scroll.clientHeight ? this.$refs.content.clientHeight : 0;
						});
						this._updateTimer = setTimeout(this.update, 3600000);
					},
					fail: () => {
						this._updateTimer = setTimeout(this.update, 3600000);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-timeline {
		.content {
			&.z-scroll {
				animation: timelineScroll 5s infinite linear;
			
				@keyframes timelineScroll {
					0% {
						transform: translate(0,0);
					}
					100% {
						transform: translate(0,-50%);
					}
				}

				ul {
					padding-bottom: 1rem;
				}
			}

			&-box {
				margin: 0 .2rem .2rem .1rem;
				overflow: hidden;
			}

			ul {
				li {
					position: relative;
					padding-left: .6rem;

					&:nth-last-child(n+2) {
						padding-bottom: .4rem;
					}

					&:before {
						content: '';
						position: absolute;
						left: .3rem;
						top: .04rem;
						box-sizing: border-box;
						width: .16rem;
						height: .16rem;
						border: .03rem solid #00F8C1;
						border-radius: 50%;
						margin-left: -.08rem;
					}

					&:nth-last-child(n+2):after {
						content: '';
						position: absolute;
						left: .3rem;
						top: .18rem;
						bottom: -.06rem;
						width: 1px;
						background: #00F8C1;
					}

					label {
						position: absolute;
						right: 100%;
						top: .02rem;
						line-height: .24rem;
						font-size: .15rem;
						white-space: nowrap;
						color: #00F8C1;
					}

					p {
						line-height: .24rem;
						font-size: .14rem;
						white-space: pre-wrap;
						color: #B7ECFF;
					}
				}
			}
		}
	}
</style>
